import { useState } from 'react';
import Button from '@/components/Button';
import TextWithEllipsis from '@/components/TextWithEllipsis';
import { TbCheck, TbHandStop, TbX } from '@/components/react-icons/main';
import { updateAiSuggestion } from '@/redux/actions/gravityActions';
import projectIssueActions from '@/screens/workflows/redux/actions/projectIssueActions.js';
import sendToast from '@/lib/sendToast';

const SuggestionCell = (props) => {
  const issue = props.issue || props.row || null;
  const column = props.column || {};
  const [loading, setLoading] = useState(false);

  const handleAction = async (actionName) => {
    const suggestion = issue?.suggestion;

    if (!suggestion) {
      return;
    }

    setLoading(true);

    if (actionName === 'accept') {
      const suggestedValue = suggestion?.suggestion?.suggestedValue;
      const suggestedLabel = suggestion?.suggestion?.suggestedLabel || null;

      if (!suggestedValue) {
        setLoading(false);
        sendToast({
          type: 'error',
          message: 'Suggested workflow ID is missing.'
        });
        return;
      }

      projectIssueActions.set('workflowId', suggestedValue, { issueId: issue.id });
      projectIssueActions.set('workflowName', suggestedLabel, { issueId: issue.id });
    }

    setLoading(false);
    updateAiSuggestion({ id: suggestion.id, path: suggestion.path, action: actionName });
    projectIssueActions.set('suggestion', null, { issueId: issue.id });
  };

  const hasWorkflow = issue?.workflowId || issue?.workflow_id;
  const hasSuggestion = !!issue?.suggestion && !hasWorkflow;

  const suggestion = issue.suggestion?.suggestion;
  const baseLabel = suggestion?.suggestedLabel || suggestion?.suggestedValue;
  const workflowId = suggestion?.suggestedValue;
  const updatedBy = suggestion?.updatedBy;
  const updatedOn = suggestion?.updatedOn;

  const formatUpdatedInfo = () => {
    if (!updatedBy || !updatedOn) {
      return '';
    }
    const date = new Date(updatedOn);
    const formattedDate = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    return ` - Updated by ${updatedBy} ${formattedDate}`;
  };

  const label = baseLabel ? `${baseLabel}${formatUpdatedInfo()}` : null;

  const handleLabelClick = () => {
    if (workflowId) {
      window.open(`/workflows/${workflowId}`, '_blank', 'noopener');
    }
  };

  const isClickable = !!workflowId;

  return (
    <div className={`comp-grid-table-cell suggestion-cell ${column.cellClassName || ''}`}>
      <TextWithEllipsis className={`suggestion-label ${isClickable ? 'clickable' : ''}`} data-title={label} onClick={isClickable ? handleLabelClick : undefined} style={isClickable ? { cursor: 'pointer' } : undefined}>
        {label || '-'}
      </TextWithEllipsis>
      {hasSuggestion && (
        <div className="suggestion-actions">
          <Button size="sm" disabled={loading} className="ghost stop-suggestion" icon={TbHandStop} title="Don't suggest this again" onClick={() => handleAction('stop')} />
          <Button size="sm" disabled={loading} className="ghost reject-suggestion" icon={TbX} title="Reject" onClick={() => handleAction('reject')} />
          <Button size="sm" disabled={loading} className="ghost accept-suggestion" icon={TbCheck} title="Accept" onClick={() => handleAction('accept')} />
        </div>
      )}
    </div>
  );
};

export default SuggestionCell;
